import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, textVariants, imageVariants } from '../../script/animation';

const Section5 = () => {
  const { t } = useTranslation();

  return (
    <motion.div 
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      className='w-full bg-red grid grid-cols-11 relative min-h-[44vh] overflow-hidden'
    >

      <motion.img 
        variants={imageVariants}  
        src='/images/banner1.jpg' 
        className='w-full h-full object-cover absolute' 
        alt="Background"
      />

     
      <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50 py-20 grid md:gap-10 lg:gap-20 content-center'>
        <div className='text-white'>
          <motion.h1 variants={textVariants} className='text-65 font-bold nunito-sans mb-5'>
            {t('section5_title')}
          </motion.h1>
          <motion.p variants={textVariants} className='text-18'>
            {t('section5_description')}
          </motion.p>
        </div>
      </div>

    
      <div className='absolute h-full w-full bg-genesisBlue top-0 left-0 mix-blend-multiply opacity-30'></div>
    </motion.div>
  );
};

export default Section5;
